import styled from 'styled-components';
import {Badge} from './GenericBadges';
import {badgeColors} from './badgeColors';

export const NoteBadge = styled(Badge)`
  background-color: ${badgeColors.backgroundColors.basket};
`;
